import { Stack } from '@mui/material';
import * as Styled from './Label.styles';

export const Label = ({helperTitle, helperMessage, labelSx, children}) => {
    return <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
        <Styled.Label sx={labelSx}>{children}</Styled.Label>
        {helperMessage !== undefined && helperMessage.length > 0 && <Styled.Tooltip
            iconSx={{ fontSize: 16}}
            iconButtonSx={{ padding: 0, marginLeft: '2px'}}
            title={helperTitle}
            message={helperMessage}                
            />
        }
    </Stack>
}
